<template>
  <div class="content">
    <v-card
      :key="$route.meta.relatorio"
      :style="
        $vuetify.breakpoint.xs
          ? 'margin: 4px'
          : 'margin: 0 18px 0 18px'
      "
    >
      <base-loading v-if="!ready" />
      <div v-else>
        <v-data-table
          :headers="headers"
          :items="dados"
          :items-per-page="5"
          :search="search"
          class="elevation-1"
          show-expand
          item-key="id"
          :expanded.sync="expanded"
          single-expand
        >
          <template
            v-for="slot in slots"
            v-slot:[slot]="{ item, index }"
          >
            <slot
              :name="slot"
              :item="item"
              :index="index"
            />
          </template>
          <template
            v-slot:top
          >
            <v-form>
              <v-row
                class="px-5 py-3"
                style="margin: 0;"
              >
                <v-col
                  cols="2"
                  style="max-width: 178px !important; margin-top: 10px;"
                >
                  <data-field
                    v-model="data_inicial"
                    :label="'Data Inicial'"
                    :data-max="data_final"
                  />
                </v-col>
                <v-col
                  cols="2"
                  style="max-width: 178px !important; margin-top: 10px;"
                >
                  <data-field
                    v-model="data_final"
                    :label="'Data Final'"
                    :data-min="data_inicial"
                  />
                </v-col>

                <v-col
                  v-for="(filtrosConfig, index) in filtroConfig"
                  :key="index"
                  cols="3"
                  style="margin-top: 10px;"
                >
                  <v-autocomplete
                    v-model="filtrosConfig.value"
                    :items="filtrosConfig.items"
                    :item-text="filtrosConfig.itemText"
                    :item-value="filtrosConfig.itemValue"
                    :label="filtrosConfig.label"
                    clearable
                    :multiple="filtrosConfig.multiple ?? true"
                    :chips="filtrosConfig.multiple ?? true"
                    :small-chips="filtrosConfig.multiple ?? true"
                    :deletable-chips="filtrosConfig.multiple ?? true"
                    class="rounded-pill mx-n2 caption font-weight-bold"
                    outlined
                    dense
                    hide-details
                    hide-selected
                    :menu-props="{ contentClass: 'rounded-lg' }"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        v-if="(filtrosConfig.multiple !== undefined ? filtrosConfig.multiple : true) && index < 2"
                        small
                        close
                        class="rounded-pill"
                        @click:close="removerItem(item)"
                      >
                        {{ item[filtrosConfig.itemText] }}
                      </v-chip>
                      <span
                        v-if="(filtrosConfig.multiple !== undefined ? filtrosConfig.multiple : true) && index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ filtrosConfig.value.length - 2 }} outros)
                      </span>
                      <span v-if="!(filtrosConfig.multiple !== undefined ? filtrosConfig.multiple : true)"
                        class="filtro-selecao-unica">{{ item[filtrosConfig.itemText] }}</span>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col
                  style="margin-top: 12px; "
                  cols="1"
                >
                  <v-btn
                    class="pa-4 text-none"
                    color="primary"
                    rounded
                    small
                    style="height: 38px;"
                    @click="onItensSelecionados"
                  >
                    <v-icon left>
                      mdi-filter
                    </v-icon>
                    Filtrar
                  </v-btn>
                </v-col>
                <v-col
                  class="d-flex align-end flex-column"
                  cols="4"
                  sm="auto"
                  md="auto"
                  lg="auto"
                  xl="auto"
                  style="margin-left: auto; margin-top: 10px;"
                >
                  <v-row>
                    <v-col>
                      <v-menu
                        open-on-hover
                        bottom
                        offset-y
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="text-none text-white"
                            color="primary"
                            v-bind="attrs"
                            rounded
                            block
                            v-on="on"
                          >
                            <v-icon
                              dark
                              left
                              style="height: 38px;"
                            >
                              mdi-file-move
                            </v-icon>
                            Exportar
                          </v-btn>
                        </template>
                        <v-list class="ma-0 pa-0">
                          <v-list-item
                            v-if="exportarPDF"
                            :key="2"
                            :class="{ active: true }"
                            @click="$emit('exportarPdf')"
                          >
                            <v-list-item-title class="mx-2 px-0">
                              <v-icon
                                color="red"
                                class="mx-2 px-0"
                              >
                                mdi-file-pdf
                              </v-icon>
                              Exportar PDF
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item
                            v-if="exportarXLSX"
                            :key="3"
                            :class="{ active: true }"
                            @click="$emit('exportarXlsx')"
                          >
                            <v-list-item-title class="mx-2 px-0">
                              <v-icon
                                color="green"
                                class="mx-2 px-0"
                              >
                                mdi-microsoft-excel
                              </v-icon>
                              Exportar XLSX
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="search"
                  label="Pesquisar"
                  class="mx-7"
                  rounded
                  dense
                  outlined
                />
              </v-col>
            </v-row>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <slot
              name="expanded-item"
              :headers="headers"
              :item="item"
            />
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { relatorios } from '../../utils/constants'
  import RelatorioStore, { BOOTSTRAP } from '@/store/modules/relatorio'

  export default {
    props: {
      headers: {
        type: Array,
        default: () => [],
      },
      exportarPDF: {
        type: Boolean,
        default: false,
      },
      dados: {
        type: Array,
        default: () => [],
      },
      filtroConfig: {
        type: Array,
        default: () => ([]),
      },
      exportarXLSX: {
        type: Boolean,
        default: false,
      },
      slots: {
        type: Array,
        default: () => ([]),
      },
    },
    data () {
      return {
        data_inicial: 'from',
        data_final: 'to',
        tipo: this.$route.meta.relatorio === relatorios.produtoresFazendas,
        search: '',
        expanded: [],
      }
    },
    computed: {
      ...mapState('relatorio', ['ready', 'relatorio']),
      ...mapGetters(['hasPermission']),
      sortBy () {
        switch (this.$route.meta.relatorio) {
          case relatorios.vendasUnidadesNegocio: return ['unidade_negocio']
          case relatorios.servicoTecnicos: return ['tecnico']
          case relatorios.atendimentoEmpresa: return ['tecnico']
          case relatorios.vendasProdutores: return ['produtor']
          case relatorios.desempenhoPromocoes: return ['unidade_negocio', 'promocao']
          case relatorios.produtosMaisVendidos: return ['percentual']
          case relatorios.produtoresSemCompra: return ['produtor', 'fazenda']
          case relatorios.produtoresFazendas: return ['produtor']
          case relatorios.servicosProdutor: return ['data_atendimento_formatada']
          default: return []
        }
      },
      sortDesc () {
        switch (this.$route.meta.relatorio) {
          case relatorios.vendasUnidadesNegocio: return [true]
          case relatorios.servicoTecnicos: return [true]
          case relatorios.vendasProdutores: return [true]
          case relatorios.desempenhoPromocoes: return [true, true]
          case relatorios.produtosMaisVendidos: return [true]
          case relatorios.produtoresSemCompra: return []
          case relatorios.produtoresFazendas: return []
          case relatorios.servicosProdutor: return [true]
          default: return []
        }
      },
    },
    created () {
      if (!this.$store.hasModule('relatorio')) { this.$store.registerModule('relatorio', RelatorioStore) }
    },
    mounted () {
      let data_i = new Date()
      data_i.setMonth(data_i.getMonth() - 3)
      data_i = data_i.toISOString().slice(0, 10)
      const data_f = new Date().toISOString().slice(0, 10)
      this.data_inicial = data_i
      this.data_final = data_f

      if (this.$route.meta.relatorio !== relatorios.produtoresFazendas) {
        this.BOOTSTRAP({ data_inicial: data_i, data_final: data_f, relatorio: this.$route.meta.relatorio, tipo: 0 })
      } else {
        this.BOOTSTRAP({ data_inicial: data_i, data_final: data_f, relatorio: this.$route.meta.relatorio, tipo: 1 })
      }
    },
    methods: {
      ...mapActions('relatorio', [BOOTSTRAP]),
      // handleDataFilter () {
      //   this.BOOTSTRAP({ data_inicial: this.data_inicial, data_final: this.data_final, relatorio: this.$route.meta.relatorio, tipo: 0 })
      // },
      valueFiltered () {
        if (!this.search || !this.dados) return this.dados || []

        const searchLower = this.search.toLowerCase()
        return this.dados.filter(item => {
          return Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchLower),
          )
        })
      },
      onItensSelecionados () {
        const todosItensSelecionados = []



          this.filtroConfig.forEach(config => {
          let valores = null;
          if (Array.isArray(config.value)) {
            valores = config.value
          } else if (config.value) {
            valores = [config.value]
          } else {
            valores = []
          }

          const itensCompletos = valores.map(id =>
          config.items.find(item =>
          item[config.itemValue] === id,
        ),
    ).filter(item => item !== undefined)

          todosItensSelecionados.push(...itensCompletos)
        })

        this.executarFiltro(todosItensSelecionados)
      },
      removerItem (item) {
        this.filtroConfig.forEach(config => {
          const itemId = item[config.itemValue]
          const index = config.value.indexOf(itemId)
          if (index > -1) {
            config.value.splice(index, 1)
          }
        })
      },

      executarFiltro (itens) {
        if ((itens && itens.length > 0) || (this.data_inicial && this.data_final)) {
          this.aplicarFiltrosMultiplos(itens)
        } else {
          this.limparFiltro()
        }
      },

      async aplicarFiltrosMultiplos (itens) {
        const parametros = {}

        this.filtroConfig.forEach(config => {
        const valores = Array.isArray(config.value)
          ? config.value
          : config.value
            ? [config.value]
            : []

        if (valores.length > 0) {
        parametros[config.filtro] = valores
        }
      })

        await this.BOOTSTRAP({
          data_inicial: this.data_inicial,
          data_final: this.data_final,
          relatorio: this.$route.meta.relatorio,
          tipo: 0,
          parametros: Object.keys(parametros).length > 0 ? parametros : null,
        })
        this.$emit('filtros-selecionados', parametros)
      },

      limparFiltro () {
        this.dadosFiltrados = this.dados
      },

      limparSelecao () {
        this.filtroConfig.forEach(config => {
          config.value = []
        })
        this.executarFiltro([])
      },
    },
  }
</script>
<style lang="css" scoped>
.filtro-selecao-unica {
  display: inline-block;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-size: 11px;
  line-height: 20px;
  height: 20px;

  padding: 0 8px;
  border-radius: 999px;
  background-color: #e0e0e0;
  color: #333;

  vertical-align: middle;
}
</style>
